import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { PaginatedProvider } from './PaginatedProvider';
import { User } from '../../types/users';
import { loadingUsersState, searchUsersState, updateUsersState, usersPageState, usersState } from '../../storage/userStates';
import { getUsers } from '../../services/usersService';

export function UsersStateProvider() {
  const updateUsers = useRecoilValue(updateUsersState);
  const resetUpdateUsers = useResetRecoilState(updateUsersState);
  const setPaginatedUsers = useSetRecoilState(usersState);
  const setLoadingAlarms = useSetRecoilState(loadingUsersState);

  return (
    <PaginatedProvider<User>
      searchState={searchUsersState}
      pageState={usersPageState}
      getPaginated={getUsers}
      setPaginated={setPaginatedUsers}
      onSearchChange={() => {
        // TODO: Do something if needed when search changes.
      }}
      onUpdateFinish={() => {
        resetUpdateUsers();
      }}
      setLoading={setLoadingAlarms}
      update={updateUsers}
    />
  );
}
